var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 48,
    viewBox: "0 0 74 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.58815 21.0002C5.99603 22.2287 2 36.728 2 36.728V47.1613H72V27.0733C72 27.0733 67.3666 15.2369 65.9111 13.5256C64.4556 11.8142 61.8407 11.8126 59.2503 11.9684C56.66 12.1241 54.5619 3.87087 52.3877 3.71515C50.2135 3.55943 47.5929 15.7057 45.5251 16.0171C43.4573 16.3285 39.8805 5.73952 37.3169 4.8052C34.7533 3.87087 31.8894 9.63255 29.2096 9.78827C26.5298 9.94399 25.0752 1.8465 22.3134 2.00222C19.5515 2.15794 18.501 18.2082 15.518 21.7788C12.8847 24.9309 11.2832 19.7229 8.58815 21.0002Z",
    fill: "url(#paint0_linear_735_25612)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 38.007C2 38.007 5.99603 22.9737 8.58815 21.6999C11.2832 20.3756 12.8847 25.7754 15.518 22.5072C18.501 18.8051 19.5515 2.16376 22.3134 2.0023C25.0752 1.84084 26.5299 10.2366 29.2096 10.0751C31.8894 9.91364 34.7533 3.93977 37.3169 4.90851C39.8805 5.87724 43.4574 16.8562 45.5251 16.5333C47.5929 16.2104 50.2135 3.61686 52.3877 3.77832C54.5619 3.93977 56.66 12.4969 59.2503 12.3355C61.8407 12.174 64.7764 12.5582 65.9111 13.95C67.0458 15.3419 72 27.9967 72 27.9967",
    stroke: "#FE5659",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_735_25612",
    x1: 37,
    y1: 2,
    x2: 37,
    y2: 47.1613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedAccount);
export default __webpack_public_path__ + "static/media/redAccount.20b7101b73298a2e43109cc3b332cebc.svg";
export { ForwardRef as ReactComponent };